import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useUsersFilterStore } from "@/features/users/stores";
import { Button } from "../ui/button";
import { UserPlus } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import { NavLink } from "react-router-dom";

const UsersPageHeader = () => {
  const { searchValue, setSearchValue } = useUsersFilterStore();
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.users.list")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          className="max-w-72 hidden lg:flex"
        />
        <NavLink to={ROUTES.USER_CREATE}>
          <Button>
            <UserPlus />
            <span className="hidden sm:inline">
              {t("modules.users.keys.add_user")}
            </span>
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default UsersPageHeader;
